module.exports = __webpack_public_path__ + "img/situp_card.858c1af1.svg";